import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {NewMessageStepper} from './NewMessageStepper'
import {NewMessageStepperV2} from './NewMessageStepperV2'

const NewMessageStepperWrapper: FC = () => {
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  return <>{isDefaultRegion ? <NewMessageStepperV2 /> : <NewMessageStepper />}</>
}

export {NewMessageStepperWrapper}
